export default function(to, from, next) {
  window.store.dispatch("Config/loadConfig").then(() => {
    next();
  });
}
